
// 聊天信息页面——主流程
const MainRoutes = Array.from({ length: 10 }, (_, i) => ({
  path: `page/chatMessage/index${i + 1}`,
  name: `page/chatMessageIndex${i + 1}`,
  component: () => import(`@/views/recognize/page/chatMessage/index${i + 1}.vue`)
}))

export default {
  path: '/recognize',
  component: {
    render (c) {
      return c('router-view')
    }
  },
  children: [

    // 聊天信息页面——主流程，开始
    ...MainRoutes
  ]
}
